import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import SearchBar from './components/SearchBar';
import FeaturedProperties from './components/FeaturedProperties';
import WhyChooseUs from './components/WhyChooseUs';
import ServicesSection from './components/ServicesSection';
import RegionalSection from './components/RegionalSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { useProperties } from '@/hooks/useProperties';

export default function Home() {
  const { properties } = useProperties();
  const featuredProperties = properties.slice(0, 4);
  const saleProperties = properties.filter((property) => property.tag === 'VENDA').slice(0, 4);
  const rentalProperties = properties.filter((property) => property.tag !== 'VENDA').slice(0, 4);

  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <SearchBar />
      <FeaturedProperties properties={featuredProperties} />
      <WhyChooseUs />
      <FeaturedProperties title="IMÓVEIS À VENDA" linkLabel="VER TODOS À VENDA" linkTo="/imoveis?finalidade=Venda" properties={saleProperties} sectionId="venda" />
      <ServicesSection />
      <FeaturedProperties title="IMÓVEIS PARA ALUGAR" linkLabel="VER TODOS PARA ALUGAR" linkTo="/imoveis?finalidade=Locação" properties={rentalProperties} sectionId="aluguel" alternate />
      <RegionalSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </main>
  );
}
